import "babel-polyfill";
import "react-app-polyfill/ie11";
import React, { Component } from "react";
import { BrowserRouter, Route, Navigate, Routes } from "react-router";
import Content from "./content";
import Show from "./show";
import MessagePoster from "./messagePoster";
import './app.scss';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/component/live/community-standup" element={<MessagePoster><Content /></MessagePoster>} exact />
          <Route path="/component/live/csharpfritz" element={<MessagePoster><Show showId="csharpfritz" /></MessagePoster>} exact />
          <Route path="/component/live/on-dotnet-live" element={<MessagePoster><Show showId="on-dotnet-live" /></MessagePoster>} exact />
          <Route path="/component/live/lets-learn-dotnet" element={<MessagePoster><Show showId="lets-learn-dotnet" /></MessagePoster>} exact />
          <Route path="/component/live/vs-toolbox" element={<MessagePoster><Show showId="vs-toolbox" /></MessagePoster>} exact />
          <Route path="/" element={<Navigate to="/component/live/community-standup" />} />
          <Route path="/health" render={() => "Healthy!"} exact />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;
